import { gql } from '@apollo/client';

export const INVITE_USER_TO_COMPANY = gql`
  mutation InviteUserToCompany($inviteData: InviteUserInput!) {
    inviteUserToCompany(inviteData: $inviteData) {
      id
      email
      firstName
      lastName
      status
      createdAt
      expiresAt
    }
  }
`;

export const ACCEPT_INVITE = gql`
  mutation AcceptInvite($acceptData: AcceptInviteInput!) {
    acceptInvite(acceptData: $acceptData)
  }
`;

export const CANCEL_INVITE = gql`
  mutation CancelInvite($inviteId: String!) {
    cancelInvite(inviteId: $inviteId)
  }
`;

export const DELETE_INVITE = gql`
  mutation DeleteInvite($inviteId: String!) {
    deleteInvite(inviteId: $inviteId)
  }
`;
